import { Values } from "./Values";

export class Line{
    start: Values;
    end: Values;
    constructor(start: Values, end: Values){
        this.start = start;
        this.end = end;
    }
}